import { IconButton } from 'component/Button/IconButton'
import { Modal } from 'component/Modal'
import { Qr } from 'component/Qr'
import { Gap, Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { imageQrModal } from 'page/InferenceScreen/ImageQrModal/ImageQrModalStore'
import { opt } from 'store/opt'
import { buildViewLink } from 'type/Inference'

export const ImageQrModal = observer(() => {
  const { inference_id, links } = imageQrModal.it.inference
  const link = buildViewLink(inference_id)

  const onClose = useLatestCallback(async () => {
    imageQrModal.close()
  })

  return <Modal gap={0} width={640} round={36}>
    <Space right>
      <IconButton size={64} action={onClose}>
        <Icon size={32} name="close" />
      </IconButton>
    </Space>
    <Space wide center>
      <Qr link={link} size={400} pad={16} />
    </Space>
    <Gap height={48} />
    <Space center>
      <Typo size={24} center balance>
        {opt.f4 ? i18n('PointYourCameraToShareTheResultOrBuyItem') : i18n('PointYourCameraToShareTheResult')}
      </Typo>
    </Space>
    <Gap height={48} />
  </Modal>
})
